import React from 'react';

import { DefinitionField } from 'components/common/fields/DefinitionField';
import LoadField from 'components/common/fields/LoadField';
import { getTranslateString } from 'helpers/eventHelper';

const EventShortResult = ({ data: { shortResult } }) => shortResult ? (
    <div className="panel-view event-result event-short-result">
        <DefinitionField translate="events.isHappened" >
            <LoadField loadName={'yesno'} fieldId={shortResult.tookPlace} fieldName="name" />
        </DefinitionField>
        <DefinitionField translate="events.appreciate" text={shortResult.evaluatedScore} />
        <DefinitionField translate={getTranslateString(shortResult.tookPlace)} text={shortResult.result} />
        <DefinitionField translate="events.percent" text={shortResult.percent} />
        <DefinitionField translate="events.comment" text={shortResult.comment} />
    </div>
) : null;

export default EventShortResult;
